import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import MultiStyleButton from "../systemUtils/MultiStyleButton";
import "../../utils/loginSignup.css";

const HeroLoginSignup = ({ phrases, onRegisterClick, onLoginClick }) => {
  const [displayedText, setDisplayedText] = useState("");
  const [cursorVisible, setCursorVisible] = useState(true);
  const [phraseIndex, setPhraseIndex] = useState(0);

  useEffect(() => {
    let typeTimeout;
    let cursorTimeout;

    const typeWord = (index) => {
      if (index < phrases[phraseIndex].length) {
        setDisplayedText((prev) => prev + phrases[phraseIndex][index]);
        typeTimeout = setTimeout(() => typeWord(index + 1), 100);
      } else {
        typeTimeout = setTimeout(() => {
          setDisplayedText("");
          setPhraseIndex((prevIndex) => (prevIndex + 1) % phrases.length);
          typeWord(0);
        }, 3000);
      }
    };

    setDisplayedText("");
    typeWord(0);

    const blinkCursor = () => {
      setCursorVisible((prev) => !prev);
      cursorTimeout = setTimeout(blinkCursor, 500);
    };

    blinkCursor();

    return () => {
      clearTimeout(typeTimeout);
      clearTimeout(cursorTimeout);
    };
  }, [phraseIndex, phrases]);

  return (
    <div className="login-container">
      <div className="login-left">
        <div className="login-word-container">
          <div className="login-word">
            {displayedText.split(" ").map((word, index) => (
              <span key={index} className="login-word-span">
                {word}
                {index < displayedText.split(" ").length - 1 ? "\u00A0" : ""}
              </span>
            ))}
            <span
              className={`login-cursor ${cursorVisible ? "visible" : "hidden"}`}
            >
              |
            </span>
          </div>
        </div>
      </div>
      <div className="login-right">
        <h2 className="login-title">Get Started with Hero</h2>
        <div className="login-buttons">
          <MultiStyleButton
            label="Register"
            buttonType="wide"
            onClick={onRegisterClick}
          />
          <MultiStyleButton
            label="Login"
            buttonType="wide"
            onClick={onLoginClick}
          />
        </div>
      </div>
    </div>
  );
};

HeroLoginSignup.propTypes = {
  phrases: PropTypes.arrayOf(PropTypes.string).isRequired,
  onRegisterClick: PropTypes.func.isRequired,
  onLoginClick: PropTypes.func.isRequired,
};

export default HeroLoginSignup;
